import { useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { addDays } from 'date-fns'
import { Spinner } from 'src/components/ui'
import { ErrorDisplay } from 'pages/app'
import {
  OpcUaHierarchyTree,
  OpcUaHieryrchySyncStatus,
} from './opc-ua-hieryrchy'
import {
  useOpcConnectionSubscriptions,
  useOpcSyncTasks,
} from './opc-ua-connection.api'
import { useLocalStorageFileUrls } from './opc-ua-hieryrchy/opc-ua-hierarchy.utils'

export function OpcUaHierarchyTab(): JSX.Element {
  const { orgId, siteId, gatewayId, connectionId } = useParams()
  if (!orgId || !siteId || !gatewayId || !connectionId)
    throw new Error('Missing orgId, siteId, gatewayId or connectionId')
  const subscriptionsQuery = useOpcConnectionSubscriptions(
    gatewayId,
    connectionId,
  )
  const connectionSyncQuery = useOpcSyncTasks(connectionId)
  const { getFileUrls, setFileUrls } = useLocalStorageFileUrls(
    connectionSyncQuery.data?.lastSuccessfulHierarchySyncTask?.id,
  )

  useEffect(() => {
    const lastSuccessful =
      connectionSyncQuery.data?.lastSuccessfulHierarchySyncTask
    if (
      lastSuccessful &&
      lastSuccessful.arrowUriNodes &&
      lastSuccessful.arrowUriReferences
    ) {
      const stored = getFileUrls()
      if (!stored.nodes || !stored.references) {
        setFileUrls(
          {
            nodes: lastSuccessful.arrowUriNodes,
            references: lastSuccessful.arrowUriReferences,
          },
          addDays(new Date(), 1),
        )
      }
    }
  }, [connectionSyncQuery.data, getFileUrls, setFileUrls])

  if (connectionSyncQuery.isLoading || subscriptionsQuery.isLoading)
    return <Spinner />

  if (connectionSyncQuery.isError || subscriptionsQuery.isError) {
    const errorQuery = connectionSyncQuery.isError
      ? connectionSyncQuery
      : subscriptionsQuery
    return (
      <ErrorDisplay
        error={errorQuery.error}
        message="Failed to fetch connection sync status"
        action={errorQuery.refetch}
      />
    )
  }
  return (
    <div className="flex flex-col gap-m py-s">
      <OpcUaHieryrchySyncStatus tasks={connectionSyncQuery.data} />
      <OpcUaHierarchyTree
        siteId={siteId}
        connectionId={connectionId}
        gatewayId={gatewayId}
        tasks={connectionSyncQuery.data}
        subscriptionId={subscriptionsQuery.data[0].id}
      />
    </div>
  )
}
